import { BehaviorSubject } from "rxjs";
import API from "./restApi";
import { AxiosRequestConfig } from "axios";

let config = require("../configuration/config");

declare var window: any;

const currentUserSubject = new BehaviorSubject(
  JSON.parse(window.localStorage.getItem("currentUser"))
);

export const serviceAuthentication = {
  login,
  logout,
  loginResult,
  currentUserSubject: currentUserSubject,
  currentUser: currentUserSubject.asObservable(),
  get currentUserValue() {
    return currentUserSubject.value;
  },
};

function login(authenticationData: any) {
  return API.post(
    `${config.serverUrl}/api/user/auth`,
    JSON.stringify(authenticationData),
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json,charset=UTF-8",
      },
    }
  );
}

function loginResult() {
  return API.post(`${config.serverUrl}/api/user/csfr`, null, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json,charset=UTF-8",
    },
  });
}

function logout() {
  var requestConfig: AxiosRequestConfig = {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json,charset=UTF-8",
    },
  };

  return API.post(`${config.serverUrl}/api/user/signout`, null, requestConfig);
}
